import React, { useEffect, useMemo, useState, Fragment } from 'react';
import { ClockIcon, UsersIcon } from 'lucide-react';
import { SPOTS_LEFT, SPOTS_TOTAL } from '../lib/constants';
function pad(n: number): string {
  return n.toString().padStart(2, '0');
}
// Countdown timer + capacity bar to create urgency around the offer.
export function UrgencyTimer() {
  // Countdown to a deadline stored in the browser so it feels persistent within the session.
  const deadline = useMemo(() => {
    const stored = sessionStorage.getItem('per_deadline');
    if (stored) return parseInt(stored, 10);
    const d = Date.now() + 23 * 60 * 60 * 1000 + 59 * 60 * 1000; // ~24h
    sessionStorage.setItem('per_deadline', d.toString());
    return d;
  }, []);
  const [remaining, setRemaining] = useState(() => Math.max(0, deadline - Date.now()));
  useEffect(() => {
    const id = setInterval(() => {
      setRemaining(Math.max(0, deadline - Date.now()));
    }, 1000);
    return () => clearInterval(id);
  }, [deadline]);
  const hours = Math.floor(remaining / (1000 * 60 * 60));
  const minutes = Math.floor(remaining % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(remaining % (1000 * 60) / 1000);
  const pct = Math.round(SPOTS_LEFT / SPOTS_TOTAL * 100);
  return <div className="rounded-2xl border border-[#c8a24a]/40 bg-[#061a33] p-4" data-id="element-173">
      <div className="flex items-center justify-center gap-2 text-[#e6c168]" data-id="element-174">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-175" />
        <p className="text-xs font-bold uppercase tracking-wide" data-id="element-176">
          La oferta termina en
        </p>
      </div>

      <div className="mt-3 flex items-center justify-center gap-2" data-id="element-177">
        {[{
        v: hours,
        l: 'Horas'
      }, {
        v: minutes,
        l: 'Min'
      }, {
        v: seconds,
        l: 'Seg'
      }].map((u, i) => <Fragment key={u.l} data-id="element-178">
            <div className="flex flex-col items-center" data-id="element-179">
              <div className="min-w-[3rem] rounded-lg bg-[#c8a24a] px-2 py-2 text-center text-2xl font-extrabold tabular-nums text-[#061a33]" data-id="element-180">
                {pad(u.v)}
              </div>
              <span className="mt-1 text-[10px] font-semibold uppercase text-blue-200" data-id="element-181">
                {u.l}
              </span>
            </div>
            {i < 2 && <span className="pb-4 text-2xl font-extrabold text-[#c8a24a]" data-id="element-182">
                :
              </span>}
          </Fragment>)}
      </div>

      <div className="mt-4" data-id="element-183">
        <div className="mb-1.5 flex items-center justify-between text-xs font-semibold text-blue-100" data-id="element-184">
          <span className="flex items-center gap-1" data-id="element-185">
            <UsersIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-186" />
            Cupos restantes
          </span>
          <span className="text-[#e6c168]" data-id="element-187">{SPOTS_LEFT} disponibles</span>
        </div>
        <div className="h-3 w-full overflow-hidden rounded-full bg-[#0b2545]" role="progressbar" aria-valuenow={SPOTS_LEFT} aria-valuemin={0} aria-valuemax={SPOTS_TOTAL} aria-label="Cupos restantes" data-id="element-188">
          <div className="h-full rounded-full bg-gradient-to-r from-[#c8a24a] to-[#e6c168]" style={{
          width: `${pct}%`
        }} data-id="element-189" />
        </div>
        <p className="mt-1.5 text-center text-[11px] text-blue-200/80" data-id="element-190">
          Los cupos se agotan rápido. Asegura el tuyo hoy.
        </p>
      </div>
    </div>;
}